import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import StartJourney from './components/StartJourney';
import WhyChooseUs from './components/WhyChooseUs';
import YogaSelfSection from './components/YogaSelfSection';
import MeetInstructors from './components/MeetInstructors';
import RecentClasses from './components/RecentClasses';
import Footer from './components/Footer';
import Testimonials from './components/Testimonial';
import Contact from './components/Contact';



function App() {
  return (
    <div className="App">
      <Navbar/>
      <Hero/>
     <StartJourney/>
     <RecentClasses/>
     <WhyChooseUs/>
     <YogaSelfSection/>
     <MeetInstructors/>
     <Testimonials/>
     <Contact/>
     <Footer/>
    </div>
  );
}

export default App;
